import { client } from "../../../api/client";

export const fetchTags = async () => {
  if (process.env.REACT_APP_USELOCALDATA === "true") {
    return require("./_local/_tagData.json");
  } else {
    try {
      const response = await client.get(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/tag");
      return response.data;
    } catch (error) {
        console.error("Error fetching Tag:", error);
        return [];
    }
  }
};


export const updateTag = async (tag) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") { 
      return { message: "success", tag: tag }
    } else {
        try {
          const response = await client.put(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/tag/" + tag.id, tag);
          return response.data;
        } catch (error) {
            console.error("Error creating tag:", error);
            return { message: "error:" + error, tag: null }
        }
      }
}

export const deleteTag = async (tagId) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") { 
      return { message: "success", tag: tagId }
    } else {
        try {
          const response = await client.delete(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/tag/" + tagId);
          return response.data;
        } catch (error) {
            console.error("Error deleting tag:", error);
            return { message: "error:" + error, tag: null }
        }
      }
}

export const createTag = async (tag) => {
    if (process.env.REACT_APP_USELOCALDATA === "true") { 
      return { message: "success", tag: {
        ...tag, 
          id: Math.floor(Math.random() * 900) + 101, // gives 101 to 1000
          createdAt: Date.now(),
          updatedAt: Date.now(),
          tagCategory: null,
          supplier: null,
          tagRevisions: []
        } }
    } else {
        try {
          const response = await client.post(process.env.REACT_APP_GATEWAY_URI,"iquoteapi/tag", tag);
          return response.data;
        } catch (error) {
            console.error("Error creating tag:", error);
            return { message: "error:" + error, tag: null }
        }
      }
}